import React, { Component } from "react";
import { Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import config from 'react-global-configuration';
import moment from 'moment'
import flat from 'flat'
import flatten from "flat";



class Companies extends Component {
  constructor(props) {
    super(props);
    
    var authUser = JSON.parse(sessionStorage.getItem("authUser"))
    this.state = {
        companies: [],
        authUser: authUser
    };

    this.getCompanies()
  }

 

  handleRowClick = (id) => {
      console.log(id)
      this.props.history.push("/company/"+id)
  }

  getCompanies = () => {
      console.log(this.state.user)
    fetch(config.get('apiUrl')+'companies',{
        headers: {
            Authorization: 'Bearer '+ this.state.authUser.access_token
        }
    })
    .then(res=>res.json())
    .then((data)=> {

        data.retailers.map(retailer => {
           retailer.clickEvent = e => this.handleRowClick(retailer.uuid)
            return null
        })

        Object.keys(data.retailers).forEach(function(key) {
            data.retailers[key] = flatten(data.retailers[key])
        });
        this.setState({
            companies: data.retailers
        })
        
    })
}

  render() {
    const data = {
      columns: [
        {
          label: "Ettevõte",
          field: "name",
          sort: "asc",
          width: 150
        },
        {
          label: "Tüüp",
          field: "type.description",
          sort: "asc",
          width: 270
        },
        {
          label: "Olek",
          field: "status",
          sort: "asc",
          width: 200
        }
      ],
      rows: this.state.companies
      
    };

    return (
      <React.Fragment>
        <div className="container-fluid">
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="page-title-box">
                <h4 className="font-size-18">Ettevõtted</h4>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/#">Töölaud</Link>
                  </li>
                  <li className="breadcrumb-item active">Ettevõtted</li>
                </ol>
              </div>
            </Col>

          </Row>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                <Link to="/newcompany" className="waves-effect">
                <Button color="primary" className="mr-1">
                               Lisa ettevõte
                            </Button>
                </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                  <MDBDataTable responsive bordered data={data} />
                </div>
              </div>
            </div>
          </div>

        </div>
      </React.Fragment>
    );
  }
}

export default Companies;
